import { APP_VERSION } from "src/environments/version";

// **************************************************************************
// SETTINGS STATE
// Application-wide settings (not page-specific)
// **************************************************************************

export interface SettingsState {
    availableLangs: string[];
    availableYllwCountries: string[];
    applicationVersion: string;
}

export const initialSettingsState: SettingsState = {
    availableLangs: ["sv", "en", "fi", "no", "da"],
    availableYllwCountries: ["SE", "FI", "NO", "DK"],
    applicationVersion: APP_VERSION,
};
 